// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__S-c48","footer":"ModalError_footer__UDSGU"};